// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileUploaded-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9d9d9;
  width: 100%;
  padding: 3px 10px;
  cursor: pointer;
}
.fileUploaded-div:hover {
  border-color: black;
}
.fileUploaded-div p {
  margin: 0;
}
.fileUploaded-div .icon {
  cursor: pointer;
  color: #b1b1b1;
  font-size: 20px;
}
.fileUploaded-div .icon:hover {
  color: hsl(0, 78%, 62%);
}
.fileUploaded-div .icon:hover {
  border-color: hsl(0, 78%, 62%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".fileUploaded-div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #d9d9d9;\n  width: 100%;\n  padding: 3px 10px;\n  cursor: pointer;\n}\n.fileUploaded-div:hover {\n  border-color: black;\n}\n.fileUploaded-div p {\n  margin: 0;\n}\n.fileUploaded-div .icon {\n  cursor: pointer;\n  color: #b1b1b1;\n  font-size: 20px;\n}\n.fileUploaded-div .icon:hover {\n  color: hsl(0, 78%, 62%);\n}\n.fileUploaded-div .icon:hover {\n  border-color: hsl(0, 78%, 62%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
